import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class RestTableService extends Service {
    constructor() {
        super();
        this.baseURL = 'dispatchio/resttable';
    }

    async resize(size, rowSize,locationBssId) {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/resize/" + size + "/" + rowSize + "/" + locationBssId, {
            crossDomain: true,
            method: 'post',
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => {
            let result = response.clone();
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    async findByMerchantBranchId(merchantBranchId) {
        return fetch(SERVER_URL + this.baseURL + "/merchantBranchId/" + merchantBranchId, {
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notificationPayNoAttention(error);
        });
    }


    async syncWebMenuToArtpos() {
        return GeneralUtils.fetchWithAuth(SERVER_URL + this.baseURL + "/sync/artpos", {
            crossDomain: true,
            method: 'put',
            headers: { 'X-Softrame-BranchId' : localStorage.getItem("merchantBranchId"),'Content-Type': 'application/json'}
        }).then(response => {
            let result = response.clone();
            GeneralUtils.notification(response);
            return GeneralUtils.responseToJson(result);
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}